import React from "react";
import { FaBars } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const AdminHeader = ({ setSidebarOpen }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    navigate("/");
  };

  return (
    <div className="admin-header">

      <div className="admin-header-left">

        <FaBars
          className="admin-menu-btn"
          onClick={() =>
            setSidebarOpen(prev => !prev)
          }
        />

        <h2>Dashboard</h2>

      </div>

      <button onClick={handleLogout}>
        Logout
      </button>

    </div>
  );
};

export default AdminHeader;